import { api } from './client'

/**
 * F-110 (REQ-065-001, REQ-062-003): "Nuovi lead" (`GET /api/leads/inbox`) e provenienza del lead di una pratica
 * (`GET /api/contracts/{id}/lead-origin`). Nessun importo in questi payload.
 */
export type LeadInboxScope = 'all' | 'unassigned' | 'assigned'

export interface LeadInboxFilters {
  scope?: LeadInboxScope | undefined
  source?: string | undefined
  campaignId?: number | undefined
  notContactedOnly?: boolean | undefined
  /** Stato del ciclo di vita (`New`, `Contacted`, ...) oppure `all`; assente = `New`. */
  status?: string | undefined
  page?: number | undefined
  pageSize?: number | undefined
}

export interface LeadInboxItem {
  id: number
  name: string
  phone: string | null
  email: string | null
  createdAt: string
  /** Codice della fonte riconosciuta; `null` se il testo salvato non è nell'elenco chiuso. */
  source: string | null
  sourceLabel: string | null
  campaign: { id: number; name: string } | null
  sector: string | null
  city: string | null
  province: string | null
  agent: { id: number; name: string | null } | null
  status: string
  operationalState: { code: string; label: string; detail?: { code: string; label: string; kind: string } } | null
  minutesSinceArrival: number
  /** Dall'ultimo tentativo di chiamata; senza tentativi, dall'arrivo. */
  minutesSinceLastContact: number
  neverContacted: boolean
  outOfSla: boolean
}

export interface LeadInboxPage {
  total: number
  page: number
  pageSize: number
  items: LeadInboxItem[]
  /** I target di speed to lead sono provvisori. */
  slaTargetsProvisional: boolean
}

export interface ContractLeadOrigin {
  contractId: number
  leadId: number
  /** `converted` = il lead convertito nella pratica; `appointment` = il lead di un appuntamento della pratica. */
  resolvedVia: 'converted' | 'appointment'
  source: string | null
  sourceCode: string | null
  sourceLabel: string | null
  campaign: { id: number; name: string; adSet: string | null; creative: string | null; sector: string | null } | null
  subCampaign: string | null
  channel: string | null
  partner: string | null
  landingPage: string | null
  clickId: string | null
  utm: { source: string | null; medium: string | null; campaign: string | null; content: string | null; term: string | null }
  provider: { id: number; name: string } | null
  acquiredAt: string
}

export const leadInboxApi = {
  list: (f: LeadInboxFilters = {}) => {
    const q = new URLSearchParams()
    if (f.scope) q.set('scope', f.scope)
    if (f.source) q.set('source', f.source)
    if (f.campaignId) q.set('campaignId', String(f.campaignId))
    if (f.notContactedOnly) q.set('notContactedOnly', 'true')
    if (f.status) q.set('status', f.status)
    q.set('page', String(f.page ?? 1))
    q.set('pageSize', String(f.pageSize ?? 25))
    return api<LeadInboxPage>(`/api/leads/inbox?${q}`)
  },

  /** `null` quando la pratica non ha nessun lead di provenienza. 404 se la pratica non è visibile. */
  origin: (contractId: number) => api<ContractLeadOrigin | null>(`/api/contracts/${contractId}/lead-origin`),
}
